/**
 * shop.zhaiji.net · 用 nav-config 覆盖主题导航（桌面 + 抽屉，中文 + 指向 zhaiji.net）
 */
(function () {
  const C = window.ZhaijiNavConfig;
  if (!C || C.hostKind() !== 'shop') return;

  const EN_LABELS = /^(Auspicious|Philosophy|Aesthetic|Shop|More)$/i;

  function desktopNavItems() {
    const groups = C.getMenuItems();
    const flat = [];
    groups.forEach(function (group) {
      group.items.forEach(function (item) {
        flat.push({ label: item.label, href: item.href, group: group.label });
      });
    });
    var pick = [
      flat.find(function (i) { return /吉宅|测算|calc/i.test(i.label); }),
      flat.find(function (i) { return /商城购买|报告|report/i.test(i.label); }),
      flat.find(function (i) { return /产品目录|全部产品|products/i.test(i.label); }),
      flat.find(function (i) { return /风水文章|Articles/i.test(i.label); }),
      flat.find(function (i) { return /会员|member/i.test(i.label); }),
    ].filter(Boolean);
    return pick.length ? pick : flat.slice(0, 5);
  }

  function linkAttrs(href) {
    var ext = /^https?:\/\//.test(href) && href.indexOf(location.origin) !== 0;
    return ext ? ' target="_blank" rel="noopener noreferrer"' : '';
  }

  function buildDrawerHtml() {
    const groups = C.getMenuItems();
    var html = '<div class="zj-nav-drawer-body zj-nav-drawer-body--shop" aria-label="站点导览">';
    groups.forEach(function (group) {
      html += '<div class="zj-nav-group"><p class="zj-nav-group-title">' + group.label + '</p>';
      group.items.forEach(function (item) {
        html += '<a class="zj-nav-link" href="' + item.href + '"' + linkAttrs(item.href) + '>' + item.label + '</a>';
      });
      html += '</div>';
    });
    html += '</div>';
    return html;
  }

  function clearInjectedState() {
    var nav = findDrawerNav();
    if (nav) {
      nav.dataset.zhaijiNavInjected = '';
    }
    document.querySelector('header-menu')?.removeAttribute('data-zhaiji-nav-patched');
  }

  function findDrawerNav() {
    return (
      document.querySelector('.menu-drawer__navigation')
      || document.querySelector('header-drawer .menu-drawer__navigation')
    );
  }

  function injectDrawer() {
    var nav = findDrawerNav();
    if (!nav) return false;
    nav.innerHTML = buildDrawerHtml();
    nav.dataset.zhaijiNavInjected = '1';
    return true;
  }

  function patchDesktopMenu() {
    var items = desktopNavItems();
    if (!items.length) return false;

    var nodes = document.querySelectorAll('header-menu .menu-list__list-item:not([slot])');
    if (!nodes.length) return false;

    var changed = false;
    nodes.forEach(function (li, index) {
      if (index >= items.length) {
        li.style.display = 'none';
        return;
      }
      li.style.display = '';
      var item = items[index];
      var a = li.querySelector('a.menu-list__link');
      var span = li.querySelector('.menu-list__link-title');
      if (!a || !span) return;
      if (a.getAttribute('href') !== item.href) {
        a.setAttribute('href', item.href);
        changed = true;
      }
      if (span.textContent !== item.label) {
        span.textContent = item.label;
        changed = true;
      }
      if (item.href.indexOf(location.origin) !== 0 && /^https?:\/\//.test(item.href)) {
        a.setAttribute('target', '_blank');
        a.setAttribute('rel', 'noopener noreferrer');
      } else {
        a.removeAttribute('target');
        a.removeAttribute('rel');
      }
      li.querySelectorAll('.menu-list__submenu').forEach(function (sub) {
        sub.style.display = 'none';
      });
      a.removeAttribute('aria-haspopup');
      a.removeAttribute('aria-controls');
      a.removeAttribute('aria-expanded');
    });

    var more = document.querySelector('header-menu li[slot="more"]');
    if (more) more.style.display = 'none';

    if (changed) {
      document.querySelector('header-menu')?.setAttribute('data-zhaiji-nav-patched', '1');
    }
    return true;
  }

  function needsDesktopPatch() {
    var items = desktopNavItems();
    var span = document.querySelector('header-menu .menu-list__link-title');
    if (!span || !items.length) return false;
    if (EN_LABELS.test((span.textContent || '').trim())) return true;
    return span.textContent !== items[0].label;
  }

  function needsDrawerPatch() {
    var nav = findDrawerNav();
    if (!nav) return false;
    var expected = C.getMenuItems()[0] && C.getMenuItems()[0].label;
    var title = nav.querySelector('.zj-nav-group-title');
    if (title && expected && title.textContent !== expected) return true;
    var text = nav.querySelector('.menu-drawer__menu-item-text');
    return text && EN_LABELS.test((text.textContent || '').trim());
  }

  function runPatch() {
    if (needsDrawerPatch() || findDrawerNav()?.querySelector('.zj-nav-drawer-body--shop')) {
      injectDrawer();
    }
    patchDesktopMenu();
  }

  function forcePatch() {
    clearInjectedState();
    injectDrawer();
    patchDesktopMenu();
  }

  function schedulePatch() {
    runPatch();
    requestAnimationFrame(runPatch);
    setTimeout(runPatch, 80);
    setTimeout(runPatch, 400);
    setTimeout(runPatch, 1200);
  }

  function bindDrawerOpen() {
    var details = document.querySelector('#Details-menu-drawer-container, details.menu-drawer-container');
    if (details) {
      details.addEventListener('toggle', function () {
        if (details.open) schedulePatch();
      });
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('header-drawer, .header__icon--menu, [aria-label*="菜单"], [aria-label*="Menu"]')) {
        schedulePatch();
      }
    });
  }

  function start() {
    schedulePatch();
    bindDrawerOpen();

    window.addEventListener('zhaiji-locale-change', function () {
      forcePatch();
    });

    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('localization-form-component, .localization-form')) {
        setTimeout(forcePatch, 300);
      }
    });

    var obs = new MutationObserver(function () {
      if (needsDrawerPatch() || needsDesktopPatch()) schedulePatch();
    });
    obs.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
    setInterval(function () {
      if (needsDrawerPatch() || needsDesktopPatch()) runPatch();
    }, 2500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
